var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comingsoon foldtl"},[_c('strong',[_vm._v("Coming Soon!")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }